
<app-header></app-header>

<!-- <div *ngIf="showfilters" class="header-btm-sort-results">
    <div class="container">
        <ul class="clearfix">
            <li>
                <div class="header-btm-sort-box">
                    <h5> Availability </h5>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-1" name="example1">
                        <label class="custom-control-label" for="cutm-check-1"> Today </label>
                    </div>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-2" name="example1">
                        <label class="custom-control-label" for="cutm-check-2"> This Week </label>
                    </div>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-3" name="example1">
                        <label class="custom-control-label" for="cutm-check-3"> Next Week </label>
                    </div>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-4" name="example1">
                        <label class="custom-control-label" for="cutm-check-4"> Next Month </label>
                    </div>
                </div>
            </li>
            <li>
                <div class="header-btm-sort-box">
                    <h5> Consultation Days </h5>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-5" name="example1">
                        <label class="custom-control-label" for="cutm-check-5"> Monday </label>
                    </div>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-6" name="example1">
                        <label class="custom-control-label" for="cutm-check-6"> Tuesday </label>
                    </div>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-7" name="example1">
                        <label class="custom-control-label" for="cutm-check-7"> Wednesday </label>
                    </div>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-8" name="example1">
                        <label class="custom-control-label" for="cutm-check-8"> Thursday </label>
                    </div>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-9" name="example1">
                        <label class="custom-control-label" for="cutm-check-9"> Friday </label>
                    </div>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-10" name="example1">
                        <label class="custom-control-label" for="cutm-check-10"> Saturday </label>
                    </div>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-11" name="example1">
                        <label class="custom-control-label" for="cutm-check-11"> Sunday </label>
                    </div>
                </div>
            </li>
            <li>
                <div class="header-btm-sort-box">
                    <h5> Timings </h5>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-12" name="example1">
                        <label class="custom-control-label" for="cutm-check-12"> Morning </label>
                    </div>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-13" name="example1">
                        <label class="custom-control-label" for="cutm-check-12"> Afternoon </label>
                    </div>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-14" name="example1">
                        <label class="custom-control-label" for="cutm-check-14"> Evening </label>
                    </div>
                </div>
            </li>
            <li>
                <div class="header-btm-sort-box">
                    <h5> Language Spoken </h5>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-15" name="example1">
                        <label class="custom-control-label" for="cutm-check-15"> English </label>
                    </div>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-16" name="example1">
                        <label class="custom-control-label" for="cutm-check-16"> Hindi </label>
                    </div>
                </div>
            </li>
            <li>
                <div class="header-btm-sort-box">
                    <h5> Gender </h5>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-17" name="example1">
                        <label class="custom-control-label" for="cutm-check-17"> Male </label>
                    </div>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-18" name="example1">
                        <label class="custom-control-label" for="cutm-check-18"> Female </label>
                    </div>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="cutm-check-19" name="example1">
                        <label class="custom-control-label" for="cutm-check-19"> Others </label>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</div> -->

<section class="bredcrumb">
  <div class="container">
      <ul class="brd-nav">
          <li> <a [routerLink]="['/']"> Home </a></li>
          <li> <a [routerLink]="['/doctors/list']"> Doctors </a></li>
          <li> <span>  {{ doctorDetail.name }} </span></li>
      </ul>
  </div>
</section>
<!--- End of bredcrumb -->

<section ngxUiLoaderBlurred blur="10" class="single-page doctors-detail padd-row">
  <div class="container">
      <div class="row">
          <div class="col-lg-4">
              <div class="doc-detail-lft grey-bg sidebar">
                  <div class="doc-detail-box">
                      <div class="doctor-box-top">
                          <div style="cursor:pointer" (click)="showImagePopup(doctorDetail.profilePicture)" class="doctor-box-img">
                              <img [src]="doctorDetail.profilePicture" alt="image">
                          </div>
                          <div class="doctor-box-top-cnt">
                              <h5>  {{ doctorDetail.name }} <span> {{ doctorDetail.speciality?.slice(0,2).join(',') }}  </span></h5>
                              <div class="doctor-box-rating">
                                  <i class="fa fa-star" aria-hidden="true"></i> <span> {{ doctorDetail.averageRatings }} | {{ doctorDetail.review?.length }} Reviews </span>
                                  <p> Registered Doctor <img style="width:30px;height:30px" src="assets/images/bluetick.png"> </p>
                              </div>
                          </div>
                      </div>
                      <div class="doc-detail-btm">
                          <ul>
                              <li>  <a target="_blank" [href]="'https://www.google.com/maps/place/'+doctorDetail.address"> <i class="fa fa-map-marker" aria-hidden="true"></i> {{ doctorDetail.address }}</a></li>
                              <ng-template [ngIf]="availability.length>0" #avilability>
                              
                                <li [ngStyle]="{ 'color': single.error ? 'red' : 'none' }" [hidden]="single?.timing==''" *ngFor="let single of availability"> <i [ngStyle]="{ 'color': single.error ? 'red' : '#26abe3' }"  class="fa fa-calendar-check-o" aria-hidden="true"></i> {{ single.timing }} </li>
                              </ng-template>
                          </ul>
                          <a style="color: #fff;" routeeLinnk="null" (click)="Booking(true)" *ngIf="(morningSlots.length>0 || afterNoonSlots.length>0 || eveningSlots.length>0) && doctorDetail?.treatments.length>0" class="btn-style"> Book Appointment </a>
                      </div>
                  </div>
                  <div class="date-slider-box">
                      <!-- <ul class="date-slider"> -->
                            <ngx-slick-carousel  class="carousel"
                            #slickModal="slick-carousel"
                            [config]="slideConfig">
                          <div ngxSlickItem class="slide" (click) ="getSlots(oneDate,i)" *ngFor="let oneDate of showDateWithDay let i=index">
                              <h4 [ngClass]="oneDate.selected ? 'selected' : '' "> {{ oneDate.day }} <span> {{ oneDate.showdate }}</span></h4>
                          </div>
                        </ngx-slick-carousel>
                         
                      <!-- </ul> -->
                  </div>
                  <div class="doc-details-timing">
                      <div id="accordion" class="accordion">
                          <div class="card mb-0">
                              <div *ngIf="morningSlots.length>0" class="card-header" data-toggle="collapse" href="#date1">
                                  <a class="card-title"> Morning </a>
                              </div>
                              <div id="date1" *ngIf="morningSlots.length>0" class="card-body collapse show" data-parent="#accordion">
                                <ul >
                                      <li *ngFor="let slot of morningSlots" (click)="timeSet(slot.status,slot.sendTime,slot)" [ngClass]="{'grey': slot.status, 'selected':slot.selected }"> {{ slot.time }} </li>
                                    
                                      </ul>
                              </div>
                              <div *ngIf="afterNoonSlots.length>0" class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#date2">
                                  <a class="card-title"> Afternoon </a>
                              </div>
                              <div *ngIf="afterNoonSlots.length>0" id="date2" class="card-body collapse" data-parent="#accordion">
                                  <ul>
                                      <li *ngFor="let slot of afterNoonSlots" (click)="timeSet(slot.status,slot.sendTime,slot)" [ngClass]="{'grey': slot.status, 'selected':slot.selected }"> {{ slot.time }}  </li>
                                    
                                  </ul>
                              </div>
                              <div *ngIf="eveningSlots.length>0" class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#date3">
                                  <a class="card-title"> Evening </a>
                              </div>
                              <div *ngIf="eveningSlots.length>0" id="date3" class="collapse" data-parent="#accordion">
                                  <ul>
                                      <li  *ngFor="let slot of eveningSlots" (click)="timeSet(slot.status,slot.sendTime,slot)" [ngClass]="{'grey': slot.status, 'selected':slot.selected }"> {{ slot.time }}  </li>
                                      
                                  </ul>
                              </div>
                          </div>
                      </div>
                      <div *ngIf="startTimeError" class="alert alert-danger">Please select a slot for appointment </div>
                  </div>
                  <div *ngIf="doctorDetail?.treatments?.length>0" class="doc-deatils-treatments">
                      <h4> Select Treatments </h4>
                      <ul>
                          <li *ngFor="let treatment of doctorDetail?.treatments let i=index" class="clearfix">
                              <div class="doc-details-treats-lft-cnt"> {{ treatment.name }}</div>
                              <form class="doc-details-treats-rght-cnt">
                                  <span class="cut-price" *ngIf="doctorDetail.discount!=0"> {{ treatment.price==0 ? '' : treatment.price }} </span>
                                  <span class="price" [innerHTML]="getPriceAfterDiscount(treatment.price,doctorDetail.discount)" > </span>
                                  <input type="checkbox" [checked]="findAlreadyAdded(treatment)" (change)="onCheckboxChange(treatment,$event)"   class="form-control">
                              </form>
                          </li>
                          
                      </ul>
                      <div *ngIf="treatmentError" class="alert alert-danger">Please select atleast one treatment</div>
                  </div>
              </div>
          </div>

          <div class="col-lg-8">
              <div class="doc-detail-nav">
                  <ul class="nav nav-pills">
                      <li class="nav-item">
                          <a class="nav-link active" data-toggle="pill" (click)="scroll(target)" href="#doc-details-1"> About </a>
                      </li>
                      <li class="nav-item">
                          <a class="nav-link" data-toggle="pill" (click)="scroll(target1)" href="#doc-details-2"> Experience </a>
                      </li>
                      <li *ngIf="doctorDetail?.services?.length>0" class="nav-item">
                          <a class="nav-link" data-toggle="pill" (click)="scroll(target2)" href="#doc-details-3"> Services </a>
                      </li>
                      <li *ngIf="doctorDetail?.blogs?.length>0" class="nav-item">
                          <a class="nav-link" data-toggle="pill" (click)="scroll(target3)" href="#doc-details-4"> Health Blogs </a>
                      </li>
                      <li *ngIf="doctorDetail?.review?.length>0" class="nav-item">
                          <a class="nav-link" data-toggle="pill" (click)="scroll(target4)" href="#doc-details-5"> Reviews </a>
                      </li>
                  </ul>
              </div>
              <div class="doc-detail-right tab-content">
                  <div #target class="tab-pane active" id="doc-details-1j">
                      <div class="doc-detail-right-main">
                          <div class="doc-detail-cnt pt-0 btm-line">
                              <h3> About </h3>
                              <p class="mb-0">{{ doctorDetail.about }} </p>
                          </div>
                                 
                       
                      </div>
                  </div>
                  <div #target1 id="doc-details-2j">
                      <div class="doc-detail-right-main">
                         
                        <div class="doc-detail-edu doc-detail-cnt btm-line">
                            <h3> Education & credentials </h3>
                            <div class="row no-gutters">
                                <div *ngIf="doctorDetail?.education.length>0" class="col-lg-8">
                                    <h5> Education </h5>
                                    <p *ngFor="let education of doctorDetail.education" class="mb-0"> {{ education }} </p>
                                    <!-- <p class="mb-0"> Lutheran Medical Center (Residency) </p> -->
                                </div>
                                <div *ngIf="doctorDetail?.languages.length>0" class="col-lg-4">
                                    <h5> LANGUAGES SPOKEN </h5>
                                    <p *ngFor="let language of doctorDetail.languages" class="mb-0">{{ language | titlecase }} </p>
                                </div>
                                <div *ngIf="doctorDetail?.awards.length>0" class="col-lg-8">
                                    <h5> EXPERIENCE, AWARDS AND PUBLICATIONS </h5>
                                    <p *ngFor="let award of doctorDetail.awards" class="mb-0"> {{ award }} </p>
                                </div>
                                <div *ngIf="doctorDetail?.membership.length>0" class="col-lg-4">
                                    <h5> MEMBERSHIP </h5>
                                    <p *ngFor="let membership of doctorDetail.membership" class="mb-0">{{ membership }} </p>
                                </div>

                                <div *ngIf="doctorDetail?.speciality.length>0" class="col-lg-8">
                                    <h5> SPECIALITY </h5>
                                    <p *ngFor="let speciality of doctorDetail.speciality" class="mb-0">{{ speciality }} </p>
                                </div>
                            </div>
                        </div>
                       
                      </div>
                  </div>
                  <div #target2 id="doc-details-3j">
                      <div *ngIf="doctorDetail?.services?.length>0" class="doc-detail-right-main">
                         
                        <div class="doc-detail-right-list doc-detail-cnt btm-line">
                            <h3> Services </h3>
                            <ul>
                                <li *ngFor="let service of doctorDetail?.services"> {{ service }} </li>
                                <!-- <li>Aesthetic Crown And Bridges </li>
                                <li>Bleaching</li>
                                <li>Artificial Teeth</li>
                                <li>Ceramic Crowns</li>
                                <li>Conscious Sedation </li>
                                <li>Conservative Dentistry </li> -->
                            </ul>
                            <ul>
                                
                                <!-- <li>Aesthetic Crown And Bridges </li>
                                <li>Bleaching</li>
                                <li>Artificial Teeth</li>
                                <li>Ceramic Crowns</li>
                                <li>Conscious Sedation </li>
                                <li>Conservative Dentistry </li> -->
                            </ul> 
                        </div>
                        
                      </div>
                  </div>
                  <div #target3 id="doc-details-4j">
                      <div *ngIf="doctorDetail?.blogs?.length>0" class="doc-detail-right-main">
                          
                        <div class="doc-detail-health-blogs doc-detail-cnt btm-line">
                            <h3> Health Blogs </h3>
                            <a *ngFor="let blog of doctorDetail?.blogs" [routerLink]="['/blog-detail/'+blog.uniquekey]"> <img [src]="blog.image"> </a>
                            <!-- <a href="javascript://"> <img src="assets/images/blog-img-2.jpg"> </a>
                            <a href="javascript://"> <img src="assets/images/blog-img-3.jpg"> </a>
                            <a href="javascript://"> <img src="assets/images/blog-img-4.jpg"> </a> -->
                        </div>
                          
                      </div>
                  </div>
                  <div #target4 id="doc-details-5j">
                      <div *ngIf="doctorDetail?.review?.length>0" class="doc-detail-right-main">
                         
                            <div class="doc-detail-client-reviews doc-detail-cnt">
                                    <h3> Reviews </h3>
                                    <ul class="doc-detail-clint-reviews-slider">
                                            <ngx-slick-carousel class="carousel"
                                            #slickModal4="slick-carousel"
                                            [config]="slideConfigCustomers"
                        >
                                        <li *ngFor="let review of doctorDetail?.review" ngxSlickItem>
                                            <div class="client-review-box">
                                                <div class="client-review-box-img">
                                                    <img [src]="review?.userId?.profilePicture" alt="image">
                                                </div>
                                                <div class="client-review-box-cnt">
                                                    <h5> {{ review?.userId?.name }} </h5>
                                                    <p> "{{ review?.comment }}"</p>
                                                    <i *ngFor='let in of counter(review?.stars) ;let i = index' class="fa fa-star" aria-hidden="true"></i>
                                                    <i class="fa fa-star-o"   *ngFor='let in of counter(5- review?.stars) ;let i = index'  aria-hidden="true"></i> 
                                         
                                          <span> {{ !review.stars ? 0 : review.stars }} </span>
                                                </div>
                                            </div>
                                        </li>
                                        </ngx-slick-carousel>
                                   
                                    </ul>
                                </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- End of doctors-detail -->

<div class="modal fade payment-booking-modal" id="book-appiontment_doctor">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <!-- Modal body -->
            <div class="modal-body">
                <div class="sign-up-form payment-form">
                    <div id="payment-screen-1">
                        <div class="doc-detail-box">
                            <div class="doctor-box-top">
                                <div class="doctor-box-img">
                                    <img [src]="doctorDetail.profilePicture" alt="image">
                                </div>
                                <div class="doctor-box-top-cnt">
                                    <h5> {{ doctorDetail.name }} <span> {{ doctorDetail?.speciality?.slice(0,2).join(',') }} | {{ doctorDetail?.education?.slice(0,2).join(',') }} </span></h5>
                                    <div *ngIf="doctorDetail.averageRatings" class="doctor-box-rating">
                                        <i *ngFor='let in of counter( parseInt(doctorDetail.averageRatings)) ;let i = index' class="fa fa-star" aria-hidden="true"></i>
                                        <i class="fa fa-star-o"   *ngFor='let in of counter(5- parseInt(doctorDetail.averageRatings)) ;let i = index'  aria-hidden="true"></i> 
                                        <span> {{ doctorDetail.review?.length }} Reviews </span>
                                      
                                    </div>
                                </div>
                            </div>
                            <div class="doc-detail-btm">
                                <div class="doc-adrs-details-modal">
                                    <div class="d-md-flex">
                                        <p> <strong> Appointment Date & Time </strong> {{ bookingDay }} | {{ sendBookingData.bookingDate }} | {{ sendBookingData.startTime }} </p>
                                        <p class="doc-adrs-rght-details-modal"> <strong> Treatment </strong> {{ sendTreatments }} </p>
                                    </div>
                                    <div class="d-md-flex">
                                        <p> <strong> Total Amount: </strong>  </p>
                                        <!-- <p class="doc-adrs-rght-details-modal"> <strong> Email </strong> rishabhjain@gmail.com </p> -->
                                        <p class="doc-adrs-rght-details-modal"> <strong>  {{ totalAmount==0 ? 'Free' : 'Rs.' + totalAmount + '/-' }} </strong>  </p>
                                    </div>
                                </div>
                                <input type="button" (click)="payWithRazor()" class="btn-style" id="open-payment-screen-2" value="Proceed to Payment">   
                                <input type="button"  class="btn-style mt-0 btn-style-grey" data-dismiss="modal" value="Cancel">   
                            </div>
                        </div>
                    </div>
                    <div id="payment-screen-2" style="display: none;">
                        <div class="payment-screen-2">
                            <div class="row no-gutters">
                                <div class="col-md-4">
                                    <div class="payment-method">
                                        <h3> Payment Methods </h3>
                                        <div class="payment-method-nav">
                                            <ul class="nav nav-pills">
                                                <li class="nav-item">
                                                    <a class="nav-link active" data-toggle="pill" href="#payment-method-1"> Debit cards </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a class="nav-link" data-toggle="pill" href="#payment-method-2"> Credit Cards </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a class="nav-link" data-toggle="pill" href="#payment-method-3"> Net Banking </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a class="nav-link" data-toggle="pill" href="#payment-method-4"> Paypal </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <div class="payment-method-desc">
                                        <div class="tab-content">
                                            <div class="tab-pane active" id="payment-method-1">
                                                <div class="payment-method-desc-navs">
                                                    <ul class="nav nav-pills">
                                                        <li class="nav-item">
                                                            <a class="nav-link active" data-toggle="pill" href="#add-card"> Add New Card </a>
                                                        </li>
                                                        <li class="nav-item">
                                                            <a class="nav-link" data-toggle="pill" href="#save-card"> Saved Cards </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="payment-method-desc-cnt">
                                                    <div class="tab-content">
                                                        <div class="tab-pane active" id="add-card">
                                                            <form>
                                                                <div class="row">
                                                                    <div class="col-md-12">
                                                                        <input type="text" class="form-control" placeholder="Card Number">
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <input type="text" class="form-control" placeholder="Expired on">
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <input type="text" class="form-control" placeholder="CVV">
                                                                    </div>
                                                                    <div class="col-md-12">
                                                                        <input type="text" class="form-control" placeholder="Card Holder Name">
                                                                    </div>
                                                                    <div class="col-md-12">
                                                                        <input type="submit" class="btn-style" value="Pay Rs. 500/-">
                                                                    </div>

                                                                </div>
                                                            </form>
                                                        </div>
                                                        <div class="tab-pane" id="save-card">
                                                            <form>
                                                                <div class="row">
                                                                    <div class="col-md-12">
                                                                        <input type="text" class="form-control" placeholder="Card Number">
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <input type="text" class="form-control" placeholder="Expired on">
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <input type="text" class="form-control" placeholder="CVV">
                                                                    </div>
                                                                    <div class="col-md-12">
                                                                        <input type="text" class="form-control" placeholder="Card Holder Name">
                                                                    </div>
                                                                    <div class="col-md-12">
                                                                        <input type="submit" class="btn-style" value="Pay Rs. 500/-">
                                                                    </div>

                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tab-pane fade" id="payment-method-2">...</div>
                                            <div class="tab-pane fade" id="menupayment-method-3">...</div>
                                            <div class="tab-pane fade" id="payment-method-4">...</div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>

                    </div> 
                </div>
            </div>
        </div>
    </div>
</div>
<input type="hidden" data-toggle="modal"
data-target="#book-appiontment_doctor" id="booking_doctor_trigge_doctor" >






<input type="hidden" data-toggle="modal"
data-target="#treatment_popup" id="treatment_popup_trigge_doctor" >



<div class="modal fade payment-booking-modal booking-popup-new-setup" id="treatment_popup">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <!-- Modal body -->
            <div class="modal-body">


<div class="doc-deatils-treatments">
    <h4> Select Treatments </h4>
    <ul>
        <li *ngFor="let treatment of doctorDetail?.treatments let i=index" class="clearfix">
            <div class="doc-details-treats-lft-cnt"> {{ treatment.name }}</div>
            <form class="doc-details-treats-rght-cnt">
                <span class="cut-price" *ngIf="doctorDetail.discount!=0"> {{ treatment.price }} </span>
                <span class="price" [innerHTML]="getPriceAfterDiscount(treatment.price,doctorDetail.discount)" > </span>
                <input type="checkbox" [checked]="findAlreadyAdded(treatment)"  (change)="onCheckboxChange(treatment,$event)"   class="form-control">
               
            </form>
        </li>
        
    </ul>
</div>
<div class="text-right">
<button class="btn btn-style" (click)="Booking(false)" [disabled]="sendBookingData.treatments.length==0" 
>Next</button>
</div>

</div>
</div>
</div>
</div>




<input type="hidden" data-toggle="modal"
data-target="#slot_popup" id="slot_popup_trigge_doctor" >

<div class="modal fade payment-booking-modal booking-popup-new-setup" id="slot_popup">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
            <!-- Modal body -->
            <div class="modal-body">

<div class="doc-details-timing">
    <div id="accordion_popup" class="accordion">
        <div class="card mb-0">
            <div *ngIf="morningSlots.length>0" class="card-header" data-toggle="collapse" href="#date1_popup" aria-expanded="false">
                <a class="card-title"> Morning </a>
            </div>
            <div *ngIf="morningSlots.length>0" id="date1_popup" class="card-body collapse" data-parent="#accordion_popup" >
                <ul>
                    <li *ngFor="let slot of morningSlots" (click)="timeSet(slot.status,slot.sendTime,slot)" [ngClass]="{'grey': slot.status, 'selected':slot.selected }"> {{ slot.time }} </li>
                </ul>
            </div>
            <div *ngIf="afterNoonSlots.length>0" class="card-header" data-toggle="collapse" data-parent="#accordion_popup" href="#date2_popup" aria-expanded="false">
                <a class="card-title"> Afternoon </a>
            </div>
            <div *ngIf="afterNoonSlots.length>0" id="date2_popup" class="card-body collapse" data-parent="#accordion_popup" >
                <ul>
                    <li *ngFor="let slot of afterNoonSlots" (click)="timeSet(slot.status,slot.sendTime,slot)" [ngClass]="{'grey': slot.status, 'selected':slot.selected }"> {{ slot.time }}  </li>
                </ul>
            </div>
            <div *ngIf="eveningSlots.length>0" class="card-header" data-toggle="collapse" data-parent="#accordion_popup" href="#date3_popup" aria-expanded="false">
                <a class="card-title"> Evening </a>
            </div>
            <div *ngIf="eveningSlots.length>0" id="date3_popup" class="collapse" data-parent="#accordion_popup" >
                <ul>
                    <li  *ngFor="let slot of eveningSlots" (click)="timeSet(slot.status,slot.sendTime,slot)" [ngClass]="{'grey': slot.status, 'selected':slot.selected }"> {{ slot.time }}  </li>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="text-right">
    <button class="btn btn-style" [disabled]="sendBookingData.startTime==0" (click)="showTreatPopup()" >Next</button>
    <button class="btn btn-style btn-style-grey ml-1" (click)="closeSlotPopup()" >Cancel</button>
</div>
</div>
</div>
</div>
</div>



<input type="hidden" id="orderImagesCLick" data-toggle="modal" data-target="#orderImagesModal">

<!-- The Modal -->
<div class="modal fade"  id="orderImagesModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- <div class="modal-header">
        <h5 class="modal-title"></h5>
      </div> -->
      <!-- Modal body -->
      <div class="modal-body text-center">
            <slideshow
            [minHeight]="'525px'"
            [showArrows]="false"
            [imageUrls]="imageDoctor"></slideshow>
        <button class="btn btn-primary" style="margin-top: 20px;"
 data-toggle="modal" data-target="#orderImagesModal">OK</button>

      </div>
    </div>
  </div>
</div>

<ngx-spinner></ngx-spinner>
<!-- <div class="loader-body" *ngIf="loading">
        <div class="loading">Loading</div>
    </div> -->

    